/* eslint-disable prefer-destructuring */
/* eslint-disable no-param-reassign */
import { AnyAction, createSlice, PayloadAction, Slice } from '@reduxjs/toolkit';
import { MARKET_DATA_API } from 'services/constants';
import { isApiFetchingCompletedAction } from '../utils';

const isAssetClassFactorsApiFullfilledAction =
  isApiFetchingCompletedAction(MARKET_DATA_API);

export interface MarketDataState {
  asOfDate: string;
  assetClassType: string;
  selectedAssetClassesFactor: string;
  selectedAssetClass: string;
  assetClassesFactors: string[];
}

const initialState: MarketDataState = {
  asOfDate: '2018-12-20',
  assetClassType: 'Level',
  selectedAssetClass: '',
  selectedAssetClassesFactor: '',
  assetClassesFactors: [],
};

export const marketDataSlice: Slice<MarketDataState> = createSlice({
  name: 'marketDataSlice',
  initialState,
  reducers: {
    setSelectedAssetClassesFactor: (state, action: PayloadAction<string>) => {
      return {
        ...state,
        selectedAssetClassesFactor: action.payload,
      };
    },
    setSelectedAssetClass: (state, action: PayloadAction<string>) => {
      return {
        ...state,
        selectedAssetClass: action.payload,
      };
    },
    setAssetClassType: (state, action: PayloadAction<string>) => {
      return {
        ...state,
        assetClassType: action.payload,
      };
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      isAssetClassFactorsApiFullfilledAction,
      (state, action: AnyAction) => {
        const { payload = [], meta } = action;
        if (
          meta?.arg?.endpointName === 'getAssetClasses' &&
          Array.isArray(payload)
        ) {
          state.selectedAssetClass = payload[0];
        }
        if (meta?.arg?.endpointName === 'getAssetClassFactors') {
          state.selectedAssetClassesFactor = payload[0];
        }
      }
    );
  },
});

export const {
  setSelectedAssetClassesFactor,
  setSelectedAssetClass,
  setAssetClassType,
} = marketDataSlice.actions;
